module.exports = __webpack_public_path__ + "static/media/car.732de2d4.png";